import { styled } from 'styled-components';

export const ScButtonClose = styled.button`
  display: block;
  position: 'absolute';
  border: none;
  top: 0px;
  right: 0px;
  background-color: transparent;
  width: 40px;
  height: 40px;
  min-width: fit-content;
  cursor: pointer;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;

  .close-icon {
    font-size: 40px;
    object-fit: contain;
    transition: transform 0.3s;
    color: ${({ theme }) => theme.blackLightColor};
  }
`;
